import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';

const ContentCopy = (): JSX.Element => <ContentCopyIcon fontSize="inherit" />;

export default ContentCopy;
